module.exports = __webpack_public_path__ + "static/media/ex18.89335a08.jpg";